<template>
  <div id="snake" :class="'normal'">
<!--    <button-->
<!--        @click="selectedScreen === 'GameScreen' ? selectedScreen = 'MenuScreen': selectedScreen = 'GameScreen' ">Click</button>-->
    <component :is="started" :gameToggle="toggler">
      <h1 slot="title">Snake</h1>
    </component>

  </div>
</template>

<script>


import MenuScreen from "@/components/menu_screen/MenuScreen";
import GameScreen from "@/components/game_screen/GameScreen";

export default {
  name: 'Snake',
  data(){
    return{
      selectedScreen:'MenuScreen',
      gameState:false,
    }
  },
  components:{
    MenuScreen: MenuScreen,
    GameScreen: GameScreen
  },
  computed:{
    started(){
      return this.gameState === false ? 'MenuScreen': 'GameScreen'
    }
  },
  methods:{
    toggler(){
      this.gameState = !this.gameState
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,700;0,800;0,900;1,600;1,700;1,800;1,900&display=swap');
:root{
  font-family: 'Poppins', sans-serif;
  --bg:#252525;
  --color: #e2e2e2;
  --shadow:5px 5px 15px rgba(0, 0 ,0, .6) , -5px -5px 15px rgba(255, 255 ,255, .1);
  --insets:  inset 5px 5px 7px rgba(0, 0 ,0, .6) ,inset -5px -5px 7px rgba(255, 255 ,255, .1);
  --snake-shadow: 0 0 5px rgba(0,0,0, .9);
  --snake:#545454;
  --snake-head:#3d6cb9;
  --card-shadow: 5px 5px 15px rgba(0, 0 ,0, .6) , -5px -5px 15px rgba(255, 255 ,255, .1),
                inset 5px 5px 15px rgba(0, 0 ,0, .6) ,inset -5px -5px 15px rgba(255, 255 ,255, .1);
}

[data-theme='light']{
  --bg:#d8d8d8;
  --color: #242424;
  --shadow: 5px 5px 15px rgba(0, 0 ,0, .2) , -5px -5px 15px rgba(255, 255 ,255, .9);
  --insets: inset 5px 5px 7px rgba(0, 0 ,0, .2) ,inset -5px -5px 7px rgba(255, 255 ,255, .6);
  --snake-shadow: 0 0 5px rgba(0,0,0, .2);
  --snake:#a8a8a8;
  --snake-head:#2f89fc;
  --card-shadow: 5px 5px 15px rgba(0, 0 ,0, .2) , -5px -5px 15px rgba(255, 255 ,255, .7),
  inset 5px 5px 15px rgba(0, 0 ,0, .2) ,inset -5px -5px 15px rgba(255, 255 ,255, .7);
}

*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body{
  background-color: var(--bg);
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.normal{
  box-shadow:var(--shadow) ;
}
.confined{
  box-shadow:var(--card-shadow) ;
}

#snake{
  width: 810px;
  height: 470px;
  background-color: var(--bg);
  border-radius: 15px;
  padding: 5px;
}

</style>